module.exports = __webpack_public_path__ + "img/freescout.04d82c43.png";